export const dateFields = ['createdDateFrom', 'createdDateTo'];

export const orQueriesFields = ['companies'];

export const searchCriteriasExclusions = [...dateFields, ...orQueriesFields];

export const DEFAULT_REQUEST_TYPE_LABEL = 'All';
